import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { areEqual } from 'Utils/equalityChecks';
import { useUser } from 'Context/User';

import { useHistory } from 'react-router-dom';
import { convertFirstLetterUppercase } from 'Utils/helpers';

import { AvatarOrInitials } from 'Components/Avatar';
import { Nav } from 'Components/Nav';
import { useSupportPanel } from 'Context/Support';
import { UserModel } from 'Containers/User/Models/UserModel';

import { userFeatureFlagsSelector } from 'Containers/User/selector';

interface Props {
  toggleSideBar: (e: any) => void;
}

const NavContainer = ({ toggleSideBar }: Props) => {
  const history = useHistory();

  const user: UserModel = useUser();

  const { openPanel, totalUnreadCount } = useSupportPanel();

  const [avatar, setAvatar] = useState('');
  const [firstName, setFirstName] = useState('');
  const { timeTracking } = useSelector(userFeatureFlagsSelector, areEqual);

  useEffect(() => {
    if (user?.id) {
      const { avatar_url: avatar, first_name: firstName } = user;
      setAvatar(avatar);
      setFirstName(convertFirstLetterUppercase(firstName));
    }
  }, [user]);

  const createProjectAction = useCallback((e: any) => {
    e.preventDefault();
    history.push('/projects/create');
  }, []);

  const toAccountOnClick = useCallback((e: any) => {
    e.preventDefault();
    history.push('/user/account');
  }, []);

  const onSupportClick = useCallback(
    (e: any) => {
      e.preventDefault();
      openPanel();
    },
    [openPanel]
  );

  return (
    <Nav
      userAvatar={<AvatarOrInitials avatar={avatar} firstName={firstName} />}
      firstName={firstName}
      timeTrackingEnabled={timeTracking}
      unreadCount={totalUnreadCount}
      toggleSideBar={toggleSideBar}
      createProjectAction={createProjectAction}
      toAccountOnClick={toAccountOnClick}
      onSupportClick={onSupportClick}
    />
  );
};

const NavContainerMemo = memo(NavContainer, areEqual);

export { NavContainerMemo as NavContainer };
